import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter
} from '@ps-design-system/components/Dialog';
import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';
import { Divider } from '@ps-design-system/components/Divider';
import { Alert, AlertDescription } from '@ps-design-system/components/Alert';
import InfoIcon from '@ps-design-system/icons/Info/Info24';

import PauseReasons from './PauseReasons';
import PauseToggle from './PauseToggle';
import SpaceInfo from './SpaceInfo';
import PauseModalTitle from './PauseModalTitle';

import { usePauseModal } from '../context/PauseModalContext';

const PauseModalStepThree = ({ onCancel, onSubmit, reason, applyToAllListingsToggle, setApplyToAllListingsToggle }) => {
  const { intl } = usePauseModal();

  return (
    <>
      <DialogHeader
        className="pause-modal-step-container"
        headerAlignment="left"
        showCloseButton
      >
        <DialogTitle className="pause-modal-dialog-header">
          <FormattedMessage id="pause.modal.step_three_title" defaultMessage="Confirm pause"/>
        </DialogTitle>
      </DialogHeader>
      <DialogBody>
        <div className="pause-listing-toggle-container">
          <PauseModalTitle isToggled={applyToAllListingsToggle} isPaused />
          <SpaceInfo/>
          <PauseToggle toggle={applyToAllListingsToggle} onToggle={setApplyToAllListingsToggle}/>
        </div>
        <Divider spacing={24} />
        <PauseReasons/>
        <Divider spacing={24} />
        <Text typeface="body-2">
          <FormattedMessage id="pause.modal.reason" defaultMessage="Reason:"/>
          {' '}
          {intl.formatMessage(reason)}
        </Text>
        <Alert isDismissable={false} className="pause-alert-container">
          <InfoIcon className="pause-alert-icon" />
          <AlertDescription className="pause-alert"><FormattedMessage id="pause.modal.ensure" defaultMessage="Please ensure you have responded to any open inquiries or booking requests."/></AlertDescription>
        </Alert>
      </DialogBody>
      <DialogFooter className="pause-dialog-footer">
        <div className="footer-container">
          <div>
            <Button
              variant="underline"
              onClick={onCancel}
              attributes={{ 'data-testing-id': 'pause-modal-cancel' }}
            >
              <FormattedMessage id="pause.modal.cancel" defaultMessage="Cancel"/>
            </Button>
          </div>
          <div className="footer-button">
            <Button appearance="purple" onClick={onSubmit} attributes={{ 'data-testing-id': 'pause-modal-submit' }}>
              <FormattedMessage id="pause.modal.pause_listing" defaultMessage="Pause listing"/>
            </Button>
          </div>
        </div>
      </DialogFooter>
    </>
  );
};

PauseModalStepThree.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  reason: PropTypes.object,
  applyToAllListingsToggle: PropTypes.bool,
  setApplyToAllListingsToggle: PropTypes.func
};

PauseModalStepThree.defaultProps = {
  onSubmit: () => {},
  onCancel: () => {},
  reason: {
    id: '',
    defaultMessage: ''
  },
  applyToAllListingsToggle: false,
  setApplyToAllListingsToggle: () => {}
};

export default PauseModalStepThree;
